module.exports = "/static/assets/cbc57fb42f120b648895bb45f239e189.gif";